<iframe width="100%" height="100%" [src]="shibbolethLogoutUrl | safe" aria-hidden="true"></iframe>
<div class="sign-in-box-container ui-g">
  <div class="sign-in-box-inner-container">
    <div class="logo-box ui-g-12 ui-md-6 ui-lg-6 ui-g-nopad ui-md-offset-1 ui-lg-offset-1 ui-g-offset-1">
      <div>
        <div class="form-field ui-g-4 ui-g-nopad">
          <img src='/assets/images/shuttle_logo.png' alt="logo">
        </div>
        <div class="logo-box">
          <div class="form-field ui-g-11 ui-g-nopad">
              <h2>The UI Ride team is updating the system. We apologize for the inconvenience. Please visit the site
                again after an hour.</h2>
            <div>
              <div class="form-field ui-g-3 ui-g-nopad">
                <button pButton class='sign-in-buttons' (click)="onLogin()" label="Login"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>